import "./MenuSkeleton.css"

// https://egghead.io/lessons/aria-use-wai-aria-attributes-to-improve-web-accessibility-of-your-skeleton-loader
// https://adrianroselli.com/2020/11/more-accessible-skeletons.html
// https://ux.stackexchange.com/questions/135956/does-a-skeleton-loader-need-to-be-accessible

function MenuSkeleton() {
    return (
        <div>
            <div className="magrinLeft12 marginTop24">
                <span className="skeleton-loader section" />
            </div>
            <div className="magrinLeft12">
                <span className="skeleton-loader section" />
            </div>
            <div className="magrinLeft12">
                <span className="skeleton-loader section" />
            </div>
        </div>
    )
}

export default MenuSkeleton
